"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BLUE_LIGHT = exports.BLUE = exports.ORANGE_LIGHT = exports.ORANGE = exports.GREEN_LIGHT = exports.GREEN = exports.GRAY_LIGHT = exports.GRAY_VERY_DARK = exports.GRAY_DARK = exports.GRAY = exports.RED_LIGHT = exports.RED = exports.GOLD_LIGHT = exports.GOLD_DARK = exports.GOLD = exports.TEAL_VERY_LIGHT = exports.TEAL_LIGHT = exports.TEAL_DARK = exports.TEAL = exports.BLACK = exports.WHITE_OFF = exports.WHITE = void 0;
var WHITE = '#FFFFFF';
exports.WHITE = WHITE;
var WHITE_OFF = '#F7FCFC';
exports.WHITE_OFF = WHITE_OFF;
var BLACK = '#000000';
exports.BLACK = BLACK;
var TEAL = '#2EABA4';
exports.TEAL = TEAL;
var TEAL_DARK = '#2E9A9C';
exports.TEAL_DARK = TEAL_DARK;
var TEAL_LIGHT = '#96D5D1';
exports.TEAL_LIGHT = TEAL_LIGHT;
var TEAL_VERY_LIGHT = '#BFEEEC';
exports.TEAL_VERY_LIGHT = TEAL_VERY_LIGHT;
var GOLD = '#FFA800';
exports.GOLD = GOLD;
var GOLD_DARK = '#FF9500';
exports.GOLD_DARK = GOLD_DARK;
var GOLD_LIGHT = '#FFDA8A';
exports.GOLD_LIGHT = GOLD_LIGHT;
var RED = '#D92B2E';
exports.RED = RED;
var RED_LIGHT = '#EA5A5A';
exports.RED_LIGHT = RED_LIGHT;
var GRAY = '#AAAAAA';
exports.GRAY = GRAY;
var GRAY_DARK = '#999999';
exports.GRAY_DARK = GRAY_DARK;
var GRAY_VERY_DARK = '#646464';
exports.GRAY_VERY_DARK = GRAY_VERY_DARK;
var GRAY_LIGHT = '#CFCFCF';
exports.GRAY_LIGHT = GRAY_LIGHT;
var GREEN = '#2ECC71';
exports.GREEN = GREEN;
var GREEN_LIGHT = '#99CC48';
exports.GREEN_LIGHT = GREEN_LIGHT;
var ORANGE = '#FF7800';
exports.ORANGE = ORANGE;
var ORANGE_LIGHT = '#FF8100';
exports.ORANGE_LIGHT = ORANGE_LIGHT;
var BLUE = '#3C9DD7';
exports.BLUE = BLUE;
var BLUE_LIGHT = '#0091FF';
exports.BLUE_LIGHT = BLUE_LIGHT;